import { Popover, PopoverOrigin } from '@mui/material';
import { Dispatch, memo, SetStateAction } from 'react';

import { TurnaroundForm } from './TurnaroundForm';

const anchorOrigin: PopoverOrigin = {
    vertical: 'center',
    horizontal: 'right',
};

const transformOrigin: PopoverOrigin = {
    vertical: 'center',
    horizontal: 'left',
};

export const TurnaroundPopover = memo(function TurnaroundPopover({
    anchorEl,
    setAnchorEl,
}: {
    anchorEl: HTMLButtonElement | null;
    setAnchorEl: Dispatch<SetStateAction<HTMLButtonElement | null>>;
}) {
    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    return (
        <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={anchorOrigin}
            transformOrigin={transformOrigin}
            PaperProps={{
                sx: {
                    backgroundColor: 'white',
                    borderRadius: '5px',
                },
            }}
        >
            <TurnaroundForm setAnchorEl={setAnchorEl} />
        </Popover>
    );
});
